import styled from "styled-components";
import * as colors from "src/styles/constants/colors";

export const Options = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const MakeDefaultContainer = styled.div`
  display: flex;
  gap: 0.25rem;
  align-items: center;
  visibility: hidden;
  opacity: 0;
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  transition:
    visibility 0s,
    opacity 0.2s ease-in-out;
  white-space: nowrap;
`;

export const OptionRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 1rem;

  &:hover {
    > div > svg {
      visibility: visible;
      display: block;
    }
    ${MakeDefaultContainer} {
      visibility: visible;
      opacity: ${(props) => (props.disabledActions ? "0.3" : "1")};
    }
  }
`;

export const OptionContainer = styled.div`
  width: 576px;
  height: 36px;
  border: 1px solid ${colors.grey40};
  padding: 0.5rem;
  line-height: 20px;
  font-size: 15px;

  display: flex;
  justify-content: space-between;
  align-items: center;

  > svg {
    min-width: 16px;
    min-height: 16px;
    visibility: hidden;
  }

  &:hover {
    > svg {
      display: block;
      visibility: visible;
    }
  }
`;

export const ActionsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  flex: 1;
  width: 100%;

  > svg {
    min-width: 16px;
    min-height: 16px;
    visibility: hidden;
  }

  &:hover {
    > svg {
      display: block;
      visibility: visible;
    }
  }
`;

export const DefaultValueContainer = styled.div`
  display: flex;

  > svg {
    cursor: pointer;
  }
`;

export const PicklistTypeContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.5rem;
`;

export const CheckboxContainer = styled.div`
  display: flex;
  align-items: center;

  // Specifically to align the info icon with the label
  > div:nth-child(2) {
    margin-left: 0.25rem;
    max-height: 20px;
  }
`;

export const CheckboxToggleContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  gap: 8rem;
`;

export const RadioGroupContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  > div {
    cursor: pointer;
  }
`;
